"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _createStyled["default"].div(_templateObject()),
    Wrapper = _createStyled["default"].div(_templateObject2()),
    Label = _createStyled["default"].label(_templateObject3()),
    Input = _createStyled["default"].input(_templateObject4());

function template() {
  var styles = this.compileStyled(_index["default"]),
      _this$props = this.props,
      disabled = _this$props.disabled,
      id = _this$props.id,
      name = _this$props.name,
      checked = _this$props.checked,
      value = _this$props.value,
      onChange = _this$props.onChange,
      className = _this$props.className,
      checkedLabel = _this$props.checkedLabel,
      unCheckedLabel = _this$props.unCheckedLabel;
  var checkedLabelComponent = null,
      uncheckedLabelComponent = null;

  if (checkedLabel) {
    checkedLabelComponent = _react["default"].createElement(Label, {
      styles: checked ? styles.labelChecked : styles.label,
      "data-qa-node": name + '__checked',
      onClick: this._check.bind(this)
    }, checkedLabel);
  }

  if (unCheckedLabel) {
    uncheckedLabelComponent = _react["default"].createElement(Label, {
      styles: !checked ? styles.labelChecked : styles.label,
      "data-qa-node": name + '__unchecked',
      onClick: this._uncheck.bind(this)
    }, unCheckedLabel);
  }

  return _react["default"].createElement(Root, {
    styles: styles.root,
    className: className
  }, _react["default"].createElement(Wrapper, {
    styles: styles.wrapper
  }, uncheckedLabelComponent, _react["default"].createElement(Input, {
    onChange: onChange,
    disabled: disabled,
    checked: Boolean(checked),
    value: value,
    id: id || this._id,
    name: name,
    type: "checkbox",
    styles: styles.field,
    ref: this._createRef
  }), _react["default"].createElement(Label, {
    styles: styles.icon,
    "data-qa-node": name,
    "data-qa-value": value + '',
    htmlFor: id || this._id
  }), checkedLabelComponent));
}